import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import { Modal } from "react-bootstrap";
import { addCardFunc, getStripeCards, setOpenCartPage, setPaymentSteps, subscriptionPlan } from "../../actions/stripe";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { stripeSecertKey } from "../../constants";

const stripePromise = loadStripe(stripeSecertKey);

const CheckoutForm = forwardRef(({ setAddCardLoader, isAdvisor, selected, onSelect }, ref) => {
  const {
    control,
    formState: { errors },
    getValues,
    reset,
  } = useForm();
  const dispatch = useDispatch();
  const { stripePlans } = useSelector((state) => state.stripe);
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);


  const handleSaveCard = async (e) => {
    if (showCardDetails) {
      e?.preventDefault();
      setMessage('');
      setLoading(true);

      if (!stripe || !elements || !getValues('name')) {
        setMessage('Error, please complete the card details.');
        setLoading(false);
        setAddCardLoader(false)
        return;
      }

      try {
        const response = await addCardFunc();
        const { clientSecret } = response;
        if (!clientSecret) {
          setMessage("Error creating setup intent.");
          setAddCardLoader(false)
          setLoading(false);
          return;
        }
        const { setupIntent, error } = await stripe.confirmCardSetup(
          clientSecret,
          {
            payment_method: {
              card: elements.getElement(CardElement),
              billing_details: { name: getValues('name') || '' },
            },
          }
        );
        if (error) {
          setMessage(`Error: ${error.message}`);
          setAddCardLoader(false)
          setLoading(false);
        } else {
          // setMessage('Card saved successfully!');
          await dispatch(getStripeCards(true));
          // dispatch(setOpenCartPage(true))
          await dispatch(subscriptionPlan(stripePlans));
          dispatch(setPaymentSteps(4));
          setAddCardLoader(false)
          setLoading(false);
        }
      } catch (err) {
        setLoading(false);
        setAddCardLoader(false)
        setMessage("Something went wrong.");
      } finally {
        setAddCardLoader(false)
        setLoading(false);
      }
    } else {
      setAddCardLoader(false)
      setShowCardDetails(true)
    }
  };

  useImperativeHandle(ref, () => ({
    handleSaveCard,
  }));

  const showHideCardDetails = () => {
    if (typeof onSelect === "function") {
      onSelect();
    }
    setShowCardDetails(prev => !prev);
  }

  return (
    <>
      <div className="row">
        <div onClick={showHideCardDetails} className={`leftCardSection ${showCardDetails && 'pb-3'}`}>
          <div className="LeftCardDetails">
            <img src="assets/img/cardIcon.svg" alt="" />
            <div className="LeftCardDetailsInner">
              <div className="nameHolder">
                <h3 className="m-0">
                  Pay with card
                </h3>
                {!showCardDetails &&
                  <p>Powered by stripe</p>
                }
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
                <path d="M15.2305 3.5625C17.8737 3.5627 20.0166 5.68767 20.0166 8.30859C20.0165 10.9294 17.8736 13.0535 15.2305 13.0537C14.0453 13.0537 12.9609 12.6264 12.125 11.9189C11.2891 12.6261 10.2054 13.0537 9.02051 13.0537C6.37727 13.0536 4.23452 10.9294 4.23438 8.30859C4.23438 5.68762 6.37718 3.56263 9.02051 3.5625C10.2053 3.5625 11.2892 3.99018 12.125 4.69727C12.9609 3.98993 14.0454 3.5625 15.2305 3.5625Z" fill="#ED0006" />
                <path d="M15.2295 3.5625C17.8729 3.5625 20.0156 5.68754 20.0156 8.30859C20.0155 10.9295 17.8728 13.0537 15.2295 13.0537C14.0443 13.0537 12.9609 12.6255 12.125 11.918C13.1534 11.0476 13.8066 9.7543 13.8066 8.30859C13.8066 6.86245 13.1538 5.56774 12.125 4.69727C12.9608 3.99009 14.0446 3.56254 15.2295 3.5625Z" fill="#F9A000" />
                <path d="M12.127 4.69727C13.1556 5.56766 13.8085 6.8617 13.8086 8.30762C13.8086 9.75352 13.1555 11.0475 12.127 11.918C11.0984 11.0475 10.4453 9.7535 10.4453 8.30762C10.4454 6.86172 11.0983 5.56766 12.127 4.69727Z" fill="#FF5E00" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.47915 11.2327H6.04629L4.97181 6.93607C4.92081 6.73842 4.81253 6.56369 4.65324 6.48134C4.25573 6.27438 3.8177 6.10968 3.33984 6.02661V5.86119H5.64807C5.96664 5.86119 6.20557 6.10968 6.24539 6.39827L6.80289 9.4976L8.23505 5.86119H9.62809L7.47915 11.2327ZM10.4245 11.2327H9.0713L10.1856 5.86119H11.5388L10.4245 11.2327ZM13.2895 7.34927C13.3294 7.05996 13.5683 6.89454 13.847 6.89454C14.2851 6.853 14.7622 6.93607 15.1604 7.14231L15.3994 5.98579C15.0012 5.82037 14.5631 5.7373 14.1656 5.7373C12.8522 5.7373 11.8965 6.48134 11.8965 7.51397C11.8965 8.29955 12.5735 8.71203 13.0513 8.96052C13.5683 9.20829 13.7674 9.37371 13.7276 9.62149C13.7276 9.99315 13.3294 10.1586 12.9319 10.1586C12.454 10.1586 11.9761 10.0347 11.5388 9.82773L11.2999 10.985C11.7777 11.1912 12.2947 11.2743 12.7726 11.2743C14.2453 11.3151 15.1604 10.5718 15.1604 9.45606C15.1604 8.05106 13.2895 7.9687 13.2895 7.34927ZM19.8964 11.2327L18.8219 5.86119H17.6678C17.4289 5.86119 17.1899 6.02661 17.1103 6.27438L15.1206 11.2327H16.5137L16.7917 10.4479H18.5033L18.6626 11.2327H19.8964ZM17.8669 7.30774L18.2644 9.33218H17.1501L17.8669 7.30774Z" fill="#172B85" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
                <path d="M15.2908 8.46718C15.6604 8.47536 16.0321 8.45056 16.4002 8.48006C16.7729 8.55087 16.8628 9.12549 16.5316 9.31369C16.3056 9.43767 16.0372 9.35986 15.7922 9.38173H15.2908V8.46718ZM16.6139 7.43202C16.696 7.72713 16.4166 7.99209 16.1375 7.95145H15.2908C15.2968 7.67315 15.2792 7.37109 15.2994 7.10745C15.6386 7.11718 15.9809 7.08762 16.3181 7.12291C16.463 7.15997 16.5842 7.28125 16.6139 7.43202ZM18.6514 3.05568C18.6671 3.61926 18.6537 4.21263 18.6582 4.78764C18.6571 7.12542 18.6604 9.46314 18.6564 11.8011C18.6415 12.6772 17.8789 13.4385 17.0244 13.456C16.1691 13.4595 15.3137 13.4565 14.4582 13.4575V9.92325C15.3903 9.91836 16.3228 9.9332 17.2545 9.91584C17.6867 9.88821 18.1601 9.59784 18.1802 9.11355C18.2311 8.62716 17.7807 8.29074 17.3531 8.2376C17.1888 8.23326 17.1936 8.18882 17.3531 8.16943C17.7609 8.07968 18.0812 7.6499 17.9612 7.21948C17.859 6.76678 17.3675 6.59157 16.9588 6.59244C16.1254 6.58667 15.2918 6.59163 14.4584 6.58996C14.4638 5.93016 14.4472 5.26965 14.4674 4.61033C14.5334 3.75001 15.3151 3.04052 16.1576 3.05591C16.989 3.05578 17.8202 3.05578 18.6514 3.05575V3.05568Z" fill="url(#paint0_linear_17566_8317)" />
                <path d="M5.0417 4.6996C5.06298 3.82484 5.82881 3.06979 6.68221 3.057C7.53437 3.05433 8.38667 3.05662 9.23883 3.05585C9.23649 5.98258 9.24345 8.90964 9.23532 11.8362C9.20249 12.7003 8.44502 13.441 7.60092 13.4563C6.74714 13.4595 5.89326 13.4567 5.03945 13.4576V9.80423C5.86879 10.0037 6.73847 10.0886 7.58453 9.95632C8.09027 9.87346 8.6436 9.62058 8.81482 9.08634C8.94082 8.62935 8.86988 8.1484 8.88864 7.67937V6.59012H7.42444C7.41786 7.31052 7.43791 8.03218 7.41385 8.75172C7.37438 9.19399 6.94423 9.47499 6.53458 9.45998C6.02654 9.46546 5.01978 9.08508 5.01978 9.08508C5.01725 7.73534 5.03452 6.04499 5.0417 4.69973V4.6996Z" fill="url(#paint1_linear_17566_8317)" />
                <path d="M9.78613 7.02963C9.70906 7.04628 9.77064 6.76232 9.75093 6.6546C9.75618 5.97351 9.73996 5.29169 9.75988 4.61109C9.82573 3.74712 10.6135 3.03586 11.4594 3.05608H13.9505C13.9482 5.98282 13.9551 8.90988 13.947 11.8365C13.9141 12.7006 13.1566 13.4412 12.3125 13.4565C11.4587 13.4598 10.6048 13.4571 9.7509 13.4579V9.4551C10.3341 9.9423 11.1266 10.0181 11.8531 10.0195C12.4008 10.0193 12.9453 9.93328 13.4772 9.80466V9.07134C12.8778 9.37553 12.1732 9.56875 11.5087 9.39398C11.0452 9.27651 10.7088 8.82039 10.7162 8.33332C10.6625 7.82681 10.9541 7.29205 11.443 7.14147C12.0499 6.948 12.7114 7.09597 13.2803 7.3475C13.4022 7.41249 13.5259 7.49309 13.4772 7.28564V6.70925C12.5257 6.47874 11.5131 6.39392 10.5572 6.64468C10.2805 6.72416 10.0109 6.84469 9.78613 7.0297V7.02963Z" fill="url(#paint2_linear_17566_8317)" />
                <defs>
                  <linearGradient id="paint0_linear_17566_8317" x1="14.4295" y1="8.03419" x2="18.6317" y2="8.03419" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#58B03A" />
                    <stop offset="1" stop-color="#55B330" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_17566_8317" x1="4.95011" y1="8.35634" x2="9.16998" y2="8.35634" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#0F6EB6" />
                    <stop offset="1" stop-color="#006DBA" />
                  </linearGradient>
                  <linearGradient id="paint2_linear_17566_8317" x1="9.74474" y1="8.13535" x2="13.9497" y2="8.13535" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#DE0D3D" />
                    <stop offset="1" stop-color="#E30138" />
                  </linearGradient>
                </defs>
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="#1F72CD" />
                <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.24029 6.02051L2.02734 11.1536H4.67655L5.00498 10.3352H5.75568L6.08411 11.1536H9.00014V10.529L9.25997 11.1536H10.7684L11.0282 10.5158V11.1536H17.0928L17.8302 10.3564L18.5207 11.1536L21.6356 11.1602L19.4156 8.60139L21.6356 6.02051H18.569L17.8512 6.80295L17.1824 6.02051H10.585L10.0184 7.34541L9.43863 6.02051H6.79495V6.62391L6.50086 6.02051H4.24029ZM4.7529 6.74942H6.04424L7.51209 10.2302V6.74942H8.92671L10.0605 9.24513L11.1053 6.74942H12.5129V10.4328H11.6564L11.6494 7.54652L10.4008 10.4328H9.63464L8.37901 7.54652V10.4328H6.61707L6.28304 9.60701H4.47839L4.14505 10.432H3.20102L4.7529 6.74942ZM16.779 6.74942H13.2965V10.4306H16.7251L17.8302 9.21059L18.8953 10.4306H20.0088L18.3904 8.60067L20.0088 6.74942H18.9437L17.8442 7.95541L16.779 6.74942ZM5.38109 7.37262L4.78654 8.84364H5.97496L5.38109 7.37262ZM14.1565 8.18444V7.51205V7.51141H16.3295L17.2776 8.58674L16.2875 9.66794H14.1565V8.93388H16.0563V8.18444H14.1565Z" fill="white" />
              </svg>
            </div>
          </div>
          <input
            type="checkbox"
            readOnly
            checked={selected}
            className="paymentMethodCheckbox"
          />
        </div>
        <div className={`cardDetailsWrapper ${showCardDetails ? "open" : ""}`}>
          <div className="cardDetailsWrapperInner">
            <div className="col-md-12 cardInputFieldSection">
              <CardElement className="cardInputField" />
            </div>
            <div className="col-md-12">
              <Controller
                control={control}
                render={({ field }) => (
                  <input
                    type="text"
                    placeholder="Name on card"
                    className="cardInputField"
                    {...field}
                  />
                )}
                name="name"
                rules={{
                  required: { value: true, message: 'Name is required' },
                }}
              />
              {errors && errors.name && (
                <span className="errorMessage">{errors?.name?.message}</span>
              )}
            </div>
            <p className="poweredbystripe">Powered by <svg xmlns="http://www.w3.org/2000/svg" width="40" height="16" viewBox="0 0 40 16" fill="none">
              <path d="M27.4512 3.28125C29.3955 3.28125 31.2289 4.92157 31.2402 7.93262C31.2402 11.2242 29.4292 12.7196 27.4404 12.7197C26.4626 12.7197 25.8736 12.3354 25.4736 12.0654L25.4619 15.0049L22.6846 15.5547V3.44727H25.1289L25.2734 4.09082C25.6623 3.75855 26.3624 3.28128 27.4512 3.28125ZM3.75586 3.28223C4.67786 3.28225 5.58874 3.41725 6.51074 3.75977V6.2002C5.66642 5.7746 4.60016 5.5352 3.75586 5.53516C3.16696 5.53516 2.81152 5.69171 2.81152 6.09668C2.81248 7.25916 7.04455 6.70966 7.05566 9.80371C7.05545 11.6622 5.46626 12.7314 3.15527 12.7314C2.19979 12.7314 1.1553 12.555 0.12207 12.1396V9.66797C1.05531 10.1456 2.23309 10.4989 3.15527 10.499C3.7775 10.499 4.22266 10.3429 4.22266 9.86523C4.22173 8.63006 0 9.08635 0 6.2207C0.000101943 4.38286 1.50035 3.28223 3.75586 3.28223ZM10.3105 3.45801H12.4219V5.66992H10.3105V9.35547C10.3105 10.8921 12.066 10.4153 12.4219 10.2803V12.3877C12.0552 12.5746 11.3886 12.7305 10.4775 12.7305C8.83307 12.7305 7.59961 11.5983 7.59961 10.0615L7.61035 1.74414L10.3223 1.2041L10.3105 3.45801ZM35.9902 3.28125C38.6236 3.28129 40.001 5.37886 40.001 8.03711C40.001 8.28634 39.9795 8.82578 39.9795 8.96094H34.5459C34.6681 10.1862 35.6234 10.539 36.7012 10.5391C37.8012 10.5391 38.6683 10.3218 39.4238 9.96875V12.0449C38.6683 12.4395 37.6679 12.7197 36.3457 12.7197C33.6347 12.7197 31.7463 11.1418 31.7461 8.0166C31.7461 5.37909 33.3458 3.28125 35.9902 3.28125ZM21.6553 12.5449H18.8662V3.45898H21.6553V12.5449ZM15.876 4.22656C16.5315 3.1051 17.8319 3.3334 18.1875 3.45801V5.84668C17.8431 5.73247 16.7318 5.58655 16.0762 6.38574V12.5439H13.2979V3.45801H15.6982L15.876 4.22656ZM26.7842 5.58594C26.151 5.586 25.7508 5.79364 25.4619 6.09473L25.4736 9.94727C25.7403 10.2171 26.129 10.4345 26.7842 10.4346C27.8064 10.4346 28.4951 9.39632 28.4951 8.00488C28.495 6.64472 27.7952 5.58594 26.7842 5.58594ZM35.9814 5.38867C35.2814 5.38867 34.5146 5.87643 34.5146 7.0498H37.3818C37.3818 5.87646 36.6592 5.3887 35.9814 5.38867ZM21.6553 2.1084L18.8662 2.66895V0.550781L21.6553 0V2.1084Z" fill="#6461FC" />
            </svg></p>
            {message && <span className="errorMessage">{message}</span>}
          </div>
        </div>
      </div>
    </>
  );
});

const AddNewCard = forwardRef(({ setAddCardLoader, isAdvisor, selected = false, onSelect }, ref) => {
  const checkoutRef = useRef(null);

  useImperativeHandle(ref, () => ({
    handleSaveCard: () => {
      return checkoutRef.current?.handleSaveCard();
    },
  }));
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm
        ref={checkoutRef}
        setAddCardLoader={setAddCardLoader}
        isAdvisor={isAdvisor}
        selected={selected}
        onSelect={onSelect}
      />
    </Elements>
  );
});

export default AddNewCard;
